module.exports = __webpack_public_path__ + "static/image@3x-f8721a150a5699bfb3ad4b0e55d3bc2e.png";